interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: React.ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
          <span className="h-px w-6 bg-primary-500"></span>
          {eyebrow}
        </div>
        <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">{title}</h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action}
    </div>
  );
}